
export enum QuoteNotificationAttributeId {
  OrderAcknowledgement = 1,
  Changes = 2,
  TrackingNumber = 3,
  Invoice = 4
}

export const QuoteNotificationAttributes = {
  [QuoteNotificationAttributeId.OrderAcknowledgement]: 'Order Acknowledgement',
  [QuoteNotificationAttributeId.Changes]: 'Changes',
  [QuoteNotificationAttributeId.TrackingNumber]: 'Tracking Number',
  [QuoteNotificationAttributeId.Invoice]: 'Invoice'
};
